import { GetMeResponse, type UserData } from '@buyerflo/core/schemas/userMembership'
import { useQuery } from '@tanstack/react-query'
import Loading from 'components/Loading'
import { createContext, useContext } from 'react'
import { useTRPC } from 'utils/trpc'

export type { UserData }

export const OrgListDataContext = createContext<{
    orgListUserData: GetMeResponse
    refreshOrgListUserData: () => void
}>(null as any)
export const useOrgListData = () => useContext(OrgListDataContext)

export const UserDataContext = createContext<{
    user: UserData
    refreshUser: () => void
    logoCacheBust: number
    bustLogoCache: () => void
}>(null as any)
export const useUserData = () => useContext(UserDataContext)

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
    const trpc = useTRPC()
    const query = useQuery(trpc.user.getMe.queryOptions())

    if (!query.data) {
        return <Loading />
    }

    return (
        <OrgListDataContext.Provider value={{ orgListUserData: query.data as GetMeResponse, refreshOrgListUserData: () => query.refetch() }}>
            {children}
        </OrgListDataContext.Provider>
    )
}
